import keycloakAxios from '@/services/axios';

export const requestRefund = async (eventId: string) => {
  const response = await keycloakAxios.post('payments/refund', {
    eventId
  });

  if (response.status >= 300) {
    throw new Error(
      `Error requesting refund: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
